import React,{useState,useEffect} from 'react'
import {Link} from 'react-router-dom';
import { GlobalDataState } from '../../../Context';
import "./FreeToWatch.css"
const FreeToWatch = () => {
    const [freeData,setfreeData]=useState({});
    const {setClickedId,setAllData}=GlobalDataState();
    const {
        state:{stack},
        dispatch,
    }=GlobalDataState();

    useEffect(()=>{
       getfreeData();
    },[])
    async function getfreeData(){
        const data=await fetch(`https://api.themoviedb.org/3/movie/top_rated?api_key=95827c3fee6b7922a023ac65e529dca2&language=en-US&page=1`)
        const json=await data.json();
        // console.log(json);
        setfreeData(json?.results);
        
    }
    function handlesetId(idx){
        setClickedId(idx);
     }
     let box = document.querySelector('.freeitems');

     const btnpressprev = () => {
         let width = box.clientWidth;
         box.scrollLeft = box.scrollLeft - width;
         console.log(width)
     }
 
     const btnpressnext = () => {
         let width = box.clientWidth;
         box.scrollLeft = box.scrollLeft + width;
         console.log(width)
     }
  return (
    <div>
    <h2>Free TO Watch</h2>
    <div className='freeitems'>
    <button className="fpre-btn" onClick={btnpressprev}><p>&lt;</p></button>
    <button className="fnext-btn" onClick={btnpressnext}><p>&gt;</p></button>
        {
            Object.values(freeData).map((item)=>(
                <div className='freeidx'>
                <Link to={"/moviesdetails"} style={{textDecoration:'none',color:'inherit'}}>
                <div className='freeitem' onClick={()=>handlesetId(item.id)}>
                {/* <div className='item'> */}
                <img className='img' src={`https://image.tmdb.org/t/p/w500/${item.poster_path}`}></img>
                <div>{item.vote_average}</div>
                <div style={{wordWrap:'wordBreak',overflow:"hidden"}}>
                    {
                        item.title? <a style={{wordWrap:'break-word',flexWrap:"wrap",overflow:"hidden",maxWidth:"11rem",width:"auto",fontWeight:"bold"}}>{item.title}</a>:<a style={{wordWrap:'break-word',flexWrap:"wrap",overflow:"hidden",maxWidth:"11rem",width:"auto",fontWeight:"bold"}}>{item.name}</a>
                    }
                </div>
                {/* <div>{item.release_date?item.release_date:<h5>upcoming</h5>}</div> */}
                </div>
                {/* </div> */}
                </Link>
                <div>
                <button onClick={()=>dispatch({type:"ADD_TO_STORE",payload:item,})}style={{borderRadius:"1rem",backgroundColor:"#16FF00"}}>ADD</button>
                <button onClick={()=>dispatch({type:"REMOVE_FROM_STORE",payload:item,})}style={{borderRadius:"1rem",backgroundColor:"#FF0303"}}>REMOVE</button>
                </div>
                </div>
            ))
        }
    </div>
    </div>
  )
}

export default FreeToWatch